export const GENERIC_OTHER_CHARGE_ITEM_NAME = 'Other Charge'

export const isOtherChargesCategory = (category?: string) =>
  category === 'OtherCharges'

export const isReusableOtherChargeOption = (option: {
  label?: string
  category?: string
}) =>
  isOtherChargesCategory(option.category) &&
  option.label === GENERIC_OTHER_CHARGE_ITEM_NAME
